<div [ngClass]="{
  'scout-pt-disabled-wrapper': scoutPoint.disabled, 
  'scout-point-card': bShowPhotoSummary
}"
[attr.title]="(scoutPoint.pointId||scoutPoint.exPointId) + (scoutPoint.disabled?' *** Disabled ***':'')">
<div
  *ngIf="scoutPoint && scoutPoint.type != 'VIA'"
  class="h-100 d-flex flex-row"
>
  <a
    href="javascript:false;"
    (click)="onShowScoutPoint(scoutPoint, scoutPath)"
    class="scout-point-link"
    [ngClass]="{
      'd-flex flex-column justify-content-center':bShowPhotoSummary,
      'disabled-scout-point':scoutPoint.disabled
    }"
    [ngStyle]="{ border: 'solid 2px ' + scoutPoint.color }"
    title="{{ scoutPoint.exPointId }} {{
      scoutPoint.envData?.bInterior
        ? 'Interior'
        : scoutPoint.envData?.bInterior === false
        ? 'Exterior'
        : ''
    }}"
  >
    {{ scoutPoint.name }}
    <i
      *ngIf="scoutPoint.envData && scoutPoint.envData.bInterior === false"
      class="fa fa-building text-muted mx-auto"
    ></i>
  </a>
  <app-scout-point-photo-browser
    *ngIf="bShowPhotoSummary"
    class="p-sm-1 small"
    [scoutTask]="scoutTask"
    [scoutPath]="scoutPath"
    [scoutPoint]="scoutPoint"
    [locked]="uiLocked"
    [photoBtnContentTmplRef]="photoBtnContentTmplRef"
    [bindContextFn]="bindContextFn"
    (photoIconDblClick)="photoIconDblClick.next($event)"
    (photoSelected)="onShowScoutPointPhoto($event)"
    (contextBound)="contextBound.next($event)"
  >
    <ng-content #photoCellRenderer select="[photo-cell-render]"></ng-content>
  </app-scout-point-photo-browser>
</div>
</div>